import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

export default function PaymentSuccess() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const session_id = searchParams.get('session_id');
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        // Countdown timer for auto-redirect
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    navigate('/dashboard');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [navigate]);

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-dark-950 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white dark:bg-dark-800 py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">
                    <CheckCircleIcon className="mx-auto h-16 w-16 text-green-500" />

                    <h2 className="mt-6 text-3xl font-extrabold text-gray-900 dark:text-white">
                        Payment Successful!
                    </h2>

                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                        Thank you for upgrading to Pro. Your account has been upgraded successfully.
                    </p>

                    <div className="mt-6">
                        <p className="text-sm text-gray-500 mb-4">
                            Redirecting to dashboard in {countdown} seconds...
                        </p>

                        <Link
                            to="/dashboard"
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                        >
                            Go to Dashboard Now
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
